module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9545_flecked_grey.dd72b9b2.jpg";